/**
 * Created by Carsten Hibbeler on 17.01.2019.
 */
import L from 'external/leaflet';

import { getFeatureId } from '../utils/geo-utils';
import { deepEqual } from 'plugin/liferay-widgets-react-web';

const idx = (id, className) => {
    if (!className) {
        console.error('Missing className');
    }
    return className + id;
};

const clone = s => {
    const t = {};
    for (let k in s) {
        if (Object.prototype.hasOwnProperty.call(s, k)) {
            t[ k ] = s[ k ];
        }
    }
    return t;
};

const diff = (oldFeaturesMap, newFeatures) => {
    const t0 = performance.now();
    oldFeaturesMap = clone(oldFeaturesMap);
    const diff = {
        added: [],
        removed: [],
        changed: [],
    };
    newFeatures.forEach(nF => {
        const id = getFeatureId(nF),
            oF = oldFeaturesMap[ id ];
        if (!oF) {
            diff.added.push(nF);
        } else {
            if (!deepEqual(nF, oF)) {
                diff.changed.push(nF);
            }
            delete oldFeaturesMap[ id ];
        }
    });
    for (let k in oldFeaturesMap) {
        if (Object.prototype.hasOwnProperty.call(oldFeaturesMap, k)) {
            diff.removed.push(oldFeaturesMap[ k ]);
        }
    }
    const t1 = performance.now();
    console.log("Diff took " + (t1 - t0) + " milliseconds.");
    return diff;
};


const RemoteDataStoreGeoJsonLayer = L.GeoJSON.extend({

    options: {
        updateFeature: function (f, oldLayer, newLayer) {
            throw new Error("deprecated");
            if (f.geometry.type === 'Point') {
                oldLayer.setLatLng(newLayer.getLatLng());
                return oldLayer;
            } else {
                return newLayer;
            }
        }
    },

    initialize: function (options) {
        L.GeoJSON.prototype.initialize.call(this, undefined, options);

        this._features = {};
        this._featureLayers = {};
    },

    getFeatureLayer: function (id, className) {
        return this._featureLayers[ idx(id, className) ];
    },

    update: function (featureCollection) {
        const oef = this.options.onEachFeature,
            changes = diff(this._features, featureCollection.features);

        if (changes.added.length + changes.changed.length + changes.removed.length === 0) {
            return;
        }

        //Add
        this.options.onEachFeature = (f, l) => {
            const fId = getFeatureId(f);

            oef && oef(f, l);

            if (this._featureLayers[ fId ]) {
                console.error("No existing layer expected");
            }

            this._featureLayers[ fId ] = l;
            this._features[ fId ] = f;
        };
        this.addData(changes.added);

        //Change
        this.options.onEachFeature = (f, l) => {
            const fId = getFeatureId(f),
                oldLayer = this._featureLayers[ fId ];

            oef && oef(f, l);

            if (oldLayer) {
                if (!this.hasLayer(oldLayer)) {
                    console.error("Missing layer: ", oldLayer);
                }
                this.removeLayer(oldLayer);
            } else {
                console.error("No existing layer expected");
            }

            this._featureLayers[ fId ] = l;
            this._features[ fId ] = f;
        };
        this.addData(changes.changed);

        //Remove
        changes.removed.forEach(f => {
            const fId = getFeatureId(f),
                oldLayer = this._featureLayers[ fId ];
            if (!oldLayer) {
                if (!this.hasLayer(oldLayer)) {
                    console.error("Missing layer: ", oldLayer);
                }
                console.error("Layer not found for ", f);
            }
            this.removeLayer(oldLayer);
            delete this._featureLayers[ fId ];
            delete this._features[ fId ];
        });

        L.Evented.prototype.fire.call(this, 'update', {
            features: this._features,
            enter: changes.added,
            update: changes.removed,
            exit: changes.changed
        });

        this.options.onEachFeature = oef;
    },

    _removeUnknown: function (known) {
        throw new Error("deprecated");
        const removed = {};
        for (let fId in this._featureLayers) {
            if (!known[ fId ]) {
                this.removeLayer(this._featureLayers[ fId ]);
                removed[ fId ] = this._features[ fId ];
                delete this._featureLayers[ fId ];
                delete this._features[ fId ];
            }
        }
        return removed;
    }

});

export default RemoteDataStoreGeoJsonLayer;


// WEBPACK FOOTER //
// ./js/layer/RemoteDataStoreGeoJsonLayer.js